import { LocalStorage } from '@mesa-labs/mesa-ui';

const localStorage = new LocalStorage();

export default localStorage;
